export const phoneNumber = "7895127272";
export const email = "contact@invitedekho.com";
